import StockTabContainer from "./StockTabContainer";
export default StockTabContainer;
